import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../utils/axiosSetup.js';
import Pagination from '../layouts/pagination.jsx';
import UpdateStatusComponent from '../../action/updatestatus.jsx';
import EditClient from './sections/edit';
import ViewClient from './sections/view.jsx';


const InactiveClients = () => {
    const [clients, setClients] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [clientId, setClientId] = useState(null);
    const [filterText, setFilterText] = useState('');
    const [channels, setChannels] = useState([]);
    const [selectedChannel, setSelectedChannel] = useState('');

    const fetchClients = async (currentPage) => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/clients?clients=inactive&page=${currentPage + 1}`)
            .then(response => {
                setClients(response.data.data);
                setPageCount(Math.ceil(response.data.meta.pagination.total / response.data.meta.pagination.per_page));
            })
            .catch(error => {
                console.error("Error fetching clients!", error);
                setClients([]);
            });
    };

    const fetchChannels = async () => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/channels`)
            .then(response => {
                setChannels(response.data.data);
            })
            .catch(error => {
                setChannels([]);
            });
    };

    useEffect(() => { 
        fetchClients(currentPage);
        fetchChannels();
    }, [currentPage]);

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
    };
    
    // Search input handler
    const filteredItems = clients.filter((item) => {
        var channel = parseInt(selectedChannel);
        const matchesName = item.name.toLowerCase().includes(filterText.toLowerCase());
        const matchesChannel = channel ? parseInt(item.channel_id) === channel : true;
        return matchesName && matchesChannel;
    });

    const MAX_LENGTH = 40;
    const truncateText = (text) => {  
        return text.length > MAX_LENGTH ? text.substring(0, MAX_LENGTH) + '...' : text;  
    };

    return (
        <>
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row align-items-center">
                        <div className="col">
                            <h3 className="page-title">Inactive Clients</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Inactive Clients</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-3 mb-3">
                        <select className="form-control"
                            value={selectedChannel}
                            onChange={(event) => {setSelectedChannel(event.target.value)}}>
                                <option value="">Select Channel</option>
                                {channels.map(channel => (
                                    <option key={channel.id} value={channel.id}>{channel.name}</option>
                                ))}
                        </select>
                    </div>
                    <div className="col-md-3">
                        <input className="form-control" type="text"
                            placeholder="Search client..." aria-label="Search Input"
                            value={filterText} onChange={(event)=>{
                                setFilterText(event.target.value)
                            }} />
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="table-responsive">
                                    <table className="table table-striped custom-table">
                                        <thead>
                                            <tr>
                                                <th>Channel Name</th>
                                                <th>Client Name</th>
                                                <th>Description</th>
                                                <th className="text-end">Status &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                </th>
                                                <th className="text-end">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                filteredItems.length > 0 ? (
                                                    filteredItems.map((client) => (
                                                        <tr key={client.id}>
                                                            <td>{client.channel_name}</td>
                                                            <td>{client.name}</td>
                                                            <td>{client.description ? truncateText(client.description) : ''}</td>
                                                            <td className="text-end">
                                                                <UpdateStatusComponent 
                                                                    url = "client/status"
                                                                    id = {client.id}
                                                                    fetchData={fetchClients} 
                                                                    status={client.status}
                                                                    />                                                                
                                                            </td>
                                                            <td className="text-end">
                                                                <div className="dropdown dropdown-action">
                                                                    <Link to="#" className="action-icon dropdown-toggle"
                                                                        data-bs-toggle="dropdown" aria-expanded="false"
                                                                            onClick={() => setClientId(`${client.id}`)}>
                                                                            <i className="material-icons">more_vert</i></Link>
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                        <Link className="dropdown-item" to="#" data-bs-toggle="modal"
                                                                            data-bs-target={`#view_client_${client.id}`}>
                                                                            <i className="fa-solid fa-eye m-r-5"></i> View</Link>
                                                                            {/* <DeleteComponent 
                                                                                url = "users"
                                                                                id = {client.id}
                                                                                fetchData={fetchClients} /> */}
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="5">No records found</td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>          
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Pagination pageCount={pageCount} handlePageClick={handlePageClick}/>
            </div>

            <EditClient list={fetchClients} clientId={clientId} />
            <ViewClient clientId={clientId} />
        </>
    );
}

export default InactiveClients